import React, { useEffect, useRef, useState } from 'react';
import '../styles/stats.css';

const statsData = [
  {
    target: 1500,
    label: 'Patients treated',
    format: '+',
    displayFn: (n) => `${(n / 1000).toFixed(1)}k`,
  },
  { target: 5, label: 'Years of experience', format: '' },
  { target: 9, label: 'Return for follow-up', format: ' in 10' },
  { target: 12, label: 'Response time', format: ' hr', prefix: '<' }
];

const AnimatedNumber = ({ target, shouldAnimate, displayFn }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!shouldAnimate) return;

    const duration = 2000;
    const start = performance.now();

    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [shouldAnimate, target]);

  return <>{displayFn ? displayFn(count) : count}</>;
};

const Stats = () => {
  const barRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimate(true);
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (barRef.current) observer.observe(barRef.current);
    return () => {
      if (barRef.current) observer.unobserve(barRef.current);
    };
  }, []);

  return (
    <section className="stats-section">
      <div className="container fade-up" ref={barRef}>
        <div className="stats-bar">

          {statsData.map((stat, i) => {

            return (
              <div className="stat-item" key={i}>
                <div className="stat-num">
                  {stat.prefix}
                  <AnimatedNumber
                    target={stat.target}
                    shouldAnimate={animate}
                    displayFn={stat.displayFn}
                  />
                  {stat.format}
                </div>
                <div className="stat-text">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;